/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Error_NetworkInputs */



/**
* | output |
* | --- |
* | "Couldn't reach the licence server. Check the internet connection, or use an activation code instead." |
*
* @param {License_Error_NetworkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_error_network = /** @type {((inputs?: License_Error_NetworkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Error_NetworkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de joindre le serveur de licences. Vérifiez la connexion, ou utilisez un code d'activation.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Lizenzserver ist nicht erreichbar. Prüfen Sie die Verbindung oder verwenden Sie einen Aktivierungscode.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile raggiungere il server delle licenze. Controlla la connessione o usa un codice di attivazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер лицензий недоступен. Проверьте подключение или используйте код активации.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo conectar con el servidor de licencias. Revisa la conexión o usa un código de activación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法连接许可证服务器。请检查网络，或改用激活码。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライセンスサーバーに接続できません。接続を確認するか、アクティベーションコードを使用してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइसेंस सर्वर से संपर्क नहीं हो सका। कनेक्शन जाँचें या सक्रियण कोड का उपयोग करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível contactar o servidor de licenças. Verifique a ligação ou use um código de ativação.")
	return /** @type {LocalizedString} */ ("Couldn't reach the licence server. Check the internet connection, or use an activation code instead.")
});